import React from 'react';
import IconSelect from '../../../components/iconSelect/IconSelect';
import useDrawTools from './useDrawTools';

const DrawToolSelection = () => {
  const { toolOptions } = useDrawTools();

  return <IconSelect options={toolOptions} />;
};

export default DrawToolSelection;
